var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDessert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(69, 110, 141)",
    width: "20px",
    height: "20px",
    viewBox: "0 0 14 14",
    role: "img",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 11.219592,3.3235446 -1.5624491,0.55347 c 0.066122,0.18123 0.1053061,0.37225 0.1053061,0.57062 0,0.90367 -0.7322449,1.64816 -1.6481633,1.64816 -0.7248979,0 -1.3420408,-0.4751 -1.562449,-1.12408 L 1,6.9137546 l 12,0 c 0,-1.3151 -0.646531,-2.54204 -1.780408,-3.59021 z m -3.5804083,0.0563 c -0.3991837,0.18122 -0.6857143,0.5902 -0.6857143,1.05796 0,0.63918 0.5240816,1.16082 1.1608163,1.16082 0.6367347,0 1.1608163,-0.52409 1.1608163,-1.16082 0,-0.63674 -0.5142857,-1.16082 -1.1608163,-1.16082 -0.3036735,-0.91347 -1.2391837,-1.70449 -1.2857143,-1.74367 -0.1053061,-0.0857 -0.2571428,-0.0759 -0.3428571,0.0294 -0.085714,0.1053 -0.075918,0.25714 0.029388,0.34285 0.2669388,0.21796 0.8938776,0.84735 1.1240817,1.47429 z M 1,10.200285 l 12,0 0,2.32408 -12,0 z m 0,-2.8016304 12,0 0,2.32408 -12,0 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDessert);
export default __webpack_public_path__ + "static/media/menuDessert.ddc59c9a0813ecaab37805dc776c4d45.svg";
export { ForwardRef as ReactComponent };